import type { FaireProductEntity } from "../../entity_types/product";

export const p_3a58vnca4g: FaireProductEntity = {
  token: "p_3a58vnca4g",
  type: "product",
  name: "Route 66 Canned Bison - Eco-Friendly Recycled Plush Gift",
  brandToken: "b_d2r2bs3j23",
  brandName: "Canned Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/dc6bcef6896f7f962c564089332c720e847001268fb0275edda252d0e487f8ef.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f6bef09477540dbee93e374d4720f9b777cf7e41be7d4a80c2f704eb4a21121.png",
    "https://cdn.faire.com/fastly/16a9bd0799842029a8799ea50fdc9ced08a13cdad89acc78f550793f1c0030bf.png",
    "https://cdn.faire.com/fastly/ffbc25a1490f8f1d730ec51ded3cfff3c01eeef50c5023b3322a14b06e02085d.png",
    "https://cdn.faire.com/fastly/2d36ce8c22cac0932683c2605236f186a1436697ab8226ade0b496934ae32ec3.png",
    "https://cdn.faire.com/fastly/d8b22a95d59bc3f45a56471f4597bedba508adc561eccc7130fd8178f2d6a5c2.png",
    "https://cdn.faire.com/fastly/da0ff0ac451ada40616a833cf4079ca14bcffad2cc0e5edc00de938f6d5d07d6.png",
    "https://cdn.faire.com/fastly/f17ff55ebecea2e18ba763b989127a8d03f8aca913729d3fe908263a61981775.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "These are super fun and popular with gift shops and novelty and boutique shops!\n•\tBison plush sealed in a can. Use a can opener to open the fun gift or choose a pop top lid!\n•\tEco-friendly: Made from recycled plastic water bottles. \n•\tPlush measures approx. 5 inches each.\n•\tFunny bison jokes and an interesting fact on the can.\n•\tDesigned and canned in the USA. Can and label made in USA. Plush made in China.\n\nIdeal for Gift Shops and Boutiques on Route 66.  Route 66 Tourists: Great for travelers stopping by your shop, seeking unique souvenirs. \n\nRoute 66 Oklahoma Wyoming Montana Idaho Missouri Illinois bison buffalo herd prairie grasslands mammal wildlife native species United States\n\n*Testers are a open can with the plush prepared for display",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:39.849Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
